import { createReducer } from 'redux-act';

import * as submitActions from './actions';

const initialState = {
    loading: false,
    isReady: false
};

const reducer = createReducer({}, initialState);

reducer.on(submitActions.setLoading, (state, loading) => ({ ...state, loading }));
reducer.on(submitActions.setIsReady, (state, isReady) => ({ ...state, isReady }));

export default reducer;
